/** SNS thrust areas — REVISED catalog (mirrors backend/data/snsThrustAreas.js) */

/** Technologies (9) */
export const INNOVATION_TECHNOLOGIES = [
  "CGC (Sales & Marketing) Tech",
  "HR Tech",
  "System Design / Data Structures & Algorithms",
  "Coding & MERN (Software Engineering / Web & Application Development)",
  "AI (Artificial Intelligence)",
  "Data Science / Data Engineering",
  "Cloud & DevOps",
  "Testing & Cybersecurity",
  "Mechanical / Electronics / Civil Technologies",
];

/** Industry verticals (9) */
export const INDUSTRY_VERTICALS = [
  "Smart Manufacturing / Auto / Aero",
  "Healthcare & Insurance",
  "Retail / Fast Moving Consumer Goods - FMCG / Supply Chain & Logistics - SCL",
  "Financial Services",
  "Media, Entertainment, Gaming",
  "Realestate",
  "Power / Oil / Energy",
  "Agri / Food",
  "Public Sector / Government Technology (GovTech)",
];

/** Grouped view for panels / docs */
export const THRUST_GROUPS = {
  technologies: [
    "CGC (Sales & Marketing) Tech",
    "HR Tech",
    "System Design / Data Structures & Algorithms",
    "Coding & MERN (Software Engineering / Web & Application Development)",
    "AI (Artificial Intelligence)",
    "Data Science / Data Engineering",
    "Cloud & DevOps",
    "Testing & Cybersecurity",
    "Mechanical / Electronics / Civil Technologies",
  ],
  /** Legacy key — Mech / Electronics / Civil are now one technology row */
  coreTech: ["Mechanical / Electronics / Civil Technologies"],
  verticals: [
    "Smart Manufacturing / Auto / Aero",
    "Healthcare & Insurance",
    "Retail / Fast Moving Consumer Goods - FMCG / Supply Chain & Logistics - SCL",
    "Financial Services",
    "Media, Entertainment, Gaming",
    "Realestate",
    "Power / Oil / Energy",
    "Agri / Food",
    "Public Sector / Government Technology (GovTech)",
  ],
  specialVerticals: [],
};

export const PROBLEM_FRAMEWORKS = [
  { id: "all", label: "YC or Unicorn + Thrust areas" },
  { id: "yc", label: "Y Combinator + Thrust areas" },
  { id: "unicorn", label: "Unicorn + Thrust areas" },
  { id: "77", label: "SNS thrust areas only" },
];
